<template>
    <div>
    <Cabecera/>
    <div class="car" v-if="!modoCompra">
      <b-carousel
      id="carousel-fade"
      style="text-shadow: 0px 0px 2px #000;"
      fade
      indicators
      img-width="1024"
      img-height="200"
    >
        <b-carousel-slide
          caption=""
          img-src="https://www.besttutor.cl/url-images/carro-1.jpg"
        ></b-carousel-slide>
        <b-carousel-slide
          caption=""
          img-src="https://www.besttutor.cl/url-images/carro-2.jpg"
        ></b-carousel-slide>
        <b-carousel-slide
          caption=""
          img-src="https://www.besttutor.cl/url-images/carro-3.jpg"
        ></b-carousel-slide>
      </b-carousel>
    </div>
    <div v-if="mostrarSpinner" style="background-color: #f58e1e;border-radius: 0.5rem;border-color: #5a1819;border-width: medium;border-style: inset;" class="d-flex align-items-center text-center m-2 p-2">
      <strong><label style="color: white;margin: auto;font-style: italic;">Buscando en el mazo...</label></strong>
      <b-spinner class="ml-auto" variant="light" type="grow"></b-spinner>
    </div>
    <router-view/>
  </div>
</template>

<script>
import Cabecera from '@/components/Cabecera.vue'
import { mapState } from 'vuex'

export default {
  name: 'Store',
  components: {
    Cabecera
  },
  computed: {
    ...mapState({
      modoCompra: state => state.modoCompra,
      mostrarSpinner: state => state.mostrarSpinner
    })
  }
}
</script>
